export const normalizeStatusDisplayValue = (displayValue) =>
  typeof displayValue === 'string'
    ? displayValue
        .replace(' (Interventional)', '')
        .replace(' (Observational)', '')
    : displayValue;

export const normalizeMasterData = (data) => {
  if (!data || !Array.isArray(data.RECSTATUS)) {
    return data;
  }

  return {
    ...data,
    RECSTATUS: data.RECSTATUS.map((item) => ({
      ...item,
      DisplayValue: normalizeStatusDisplayValue(item.DisplayValue),
    })),
  };
};

export const normalizeSearchResults = (results) =>
  Array.isArray(results)
    ? results.map((item) => ({
        ...item,
        StatusDisplay: normalizeStatusDisplayValue(item.StatusDisplay),
      }))
    : results;

export const normalizeStudyDetails = (studyDetails) => {
  if (!studyDetails) {
    return studyDetails;
  }

  return {
    ...studyDetails,
    display_status: normalizeStatusDisplayValue(studyDetails.display_status),
  };
};
